import axios from 'axios'
import { BASE_FIREBASE_FUNCTIONS_URL } from '../config/config'

/**
 * Create session cookie for SSO
 * Call this after successful Firebase authentication to enable
 * cookie-based SSO across all Loop platforms
 *
 * @param idToken - Firebase ID token from currentUser.getIdToken()
 * @returns Response indicating success/failure
 */
export const createSessionCookie = async (idToken: string) => {
  try {
    const res = await axios.post(
      `${BASE_FIREBASE_FUNCTIONS_URL}/authSignin`,
      { idToken },
      { withCredentials: true }
    )
    return res.data
  } catch (err: any) {
    console.error('createSessionCookie error', err)
    throw err
  }
}
